// extracted by mini-css-extract-plugin
module.exports = {"root":"GameIntro_root__jeOvs","rules":"GameIntro_rules__3ioQZ","form":"GameIntro_form__10KSq","wrapper":"GameIntro_wrapper__1Xx0e","checkmark":"GameIntro_checkmark__3IiKA"};